import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoInCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1667 23.8334C18.61 23.8334 23.8333 18.61 23.8333 12.1667C23.8333 5.72335 18.61 0.5 12.1667 0.5C5.72333 0.5 0.5 5.72335 0.5 12.1667C0.5 18.61 5.72333 23.8334 12.1667 23.8334Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.167 11.1074V18.5313",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.167 6.86426V7.92482",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInfoInCircle;
